import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { ServicesService } from '../../../services/services.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';

@Component({
  selector: 'app-services-new-sdr',
  templateUrl: './services-new-sdr.component.html',
  styleUrls: ['./services-new-sdr.component.scss']
})
export class ServicesNewSdrComponent implements OnInit {

    constructor(private route: ActivatedRoute,
        private router: Router, private servicesService: ServicesService,
        public authentication: AuthenticationService,
        private common: CommonService) { }

    isError: boolean = false;
    errorMessage: string = "";

    //userData: any = {};

    btnSubmitDisabled: boolean = false;
    btnSubmitText: string = "Send";


    pagecode: string = "serv-submit";
    accessdenied: boolean = false;
    module: string = "services";

    ngOnInit(): void {
        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        var sfAccountID = this.authentication.userData.sfAccountID;
                        var sfContactId = this.authentication.userData.sfContactId

                        if (sfAccountID && sfAccountID != "" && sfContactId && sfContactId != "") {
                            this.service = {
                                accountId: sfAccountID,
                                ContactId: sfContactId,
                                Status: "New",
                                Origin: "Web",
                                description: "",
                            };
                        }
                        else {
                            //message that the user doesnot have enough privilege to submit new service.
                            this.accessdenied = true;
                        }

                        window.scroll(0, 0);

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );


        });

        //this.userData = this.authentication.userData;
    }
    service: any = {
        accountId: "",
        ContactId: "",
        Status: "New",
        Origin: "Web",
        description: "",
    }

    submitAttachments(sdrId: any) {


        var files = this.files;
        var attachmentsObj = {
            ParentId: sdrId,
            attachments: []
        };
        for (var i = 0; i < files.length; i++) {

            var file = files[i];
            var isLastIndex = false;
            if (i == files.length - 1)
                isLastIndex = true;
            this.getFile(file, attachmentsObj, isLastIndex, sdrId);
        }

    }
    getFile(file: any, attachmentsObj: any, isLastIndex: any, sdrId: any) {
        var reader = new FileReader();
        var _self = this;
        reader.onload = function (readerEvt) {

            var binaryString = readerEvt.target!.result!.toString().split(',')[1];
            var contentType = file.type;
            if (file.name.toLowerCase().indexOf(".zip") !== -1 && file.type === "")
                contentType = "application/x-zip-compressed";
            attachmentsObj.attachments.push({
                ContentType: contentType,
                Name: file.name,
                Body: binaryString
            });
            if (isLastIndex) {
                var _this = _self;
                _self.servicesService.addAttachment(attachmentsObj).subscribe(
                    (res: any) => {
                        _this.btnSubmitText = "Submit";
                        _this.btnSubmitDisabled = false;
                        _this.common.ShowMessage('success', 'Your request was successfully submitted', '')
                        _this.clearSdr();
                        _this.router.navigate(['services/service-sdr-details/' + sdrId]);
                    },
                    (err: any) => {
                        console.log("addAttachment err", err);
                    }
                );

            }
        };
        reader.readAsDataURL(file);
    }
    clearSdr() {
        this.service = {
            accountId: this.authentication.userData.sfAccountID,
            ContactId: this.authentication.userData.sfContactId,
            Status: "New",
            Origin: "Web",
            description: "",
        };
    }
    submit() {
        console.log("this.service")
        console.log(this.service)

        if (this.formValidation()) {
            //validation
            this.btnSubmitText = "Submitting";
            this.btnSubmitDisabled = true;

            this.servicesService.submitSDR(this.service, this.authentication.userData.id).subscribe(
                (res: any) => {
                    if (res.Status) {
                        if (this.files.length > 0) {
                            this.submitAttachments(res['SDRObject'].Id);
                        }
                        else {
                            this.btnSubmitText = "Submit";
                            this.btnSubmitDisabled = false;
                            this.clearSdr();
                            this.router.navigate(['services/service-sdr-details/' + res['SDRObject'].Id]);
                        }

                    }
                },
                (err: any) => {
                    this.btnSubmitText = "Submit";
                    this.btnSubmitDisabled = false;
                    console.log("submitSupportCase", err);
                }
            );
        }
    }
    formValidation() {
        if (this.service.description === '') {
            this.common.ShowMessage('error', 'Service Description is mandatory', '')
            return false;
        }
        return true;
    }
    files: any = [];
    filesSelect(selectedFiles: any): void {
        for (var i = 0; i < selectedFiles.target.files.length; i++) {
            this.files.push(selectedFiles.target.files[i]);
        }
    }

    removeFile(fileIndex: any) {
        this.files.splice(fileIndex, 1);
    }
}

